/* tslint:disable:max-line-length */
import { TreoNavigationItem } from '@treo/components/navigation';

export const defaultNavigation: TreoNavigationItem[] = [
  {
    id: 'wallet',
    title: 'sidebar:wallet',
    type: 'basic',
    icon: 'fa-credit-card',
    link: '/wallet',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    type: 'group',
    title: 'sidebar:group1',
  },
  {
    id: 'student-payments',
    title: 'sidebar:studentPayments',
    subtitle: 'sidebar:studentPaymentsSubtitle',
    type: 'basic',
    icon: 'fa-arrow-circle-down',
    iconClasses: 'text-[#27ae60]',
    link: '/student-payments',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    id: 'infunds',
    title: 'sidebar:invoiceFunds',
    subtitle: 'sidebar:invoiceFundsSubtitle',
    type: 'basic',
    icon: 'fa-arrow-circle-down',
    iconClasses: 'text-[#2097F6]',
    link: '/invoice-funds',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    type: 'group',
    title: 'sidebar:group2',
  },
  {
    id: 'comissions',
    title: 'sidebar:walletComissions',
    subtitle: 'sidebar:walletComissionsSubtitle',
    type: 'basic',
    icon: 'fa-arrow-circle-right',
    iconClasses: 'text-[#27ae60]',
    link: '/commission-request',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    type: 'group',
    title: 'sidebar:group3',
  },
  {
    id: 'payouts',
    title: 'sidebar:walletPayouts',
    subtitle: 'sidebar:walletPayoutsSubtitle',
    type: 'basic',
    icon: 'fa-arrow-circle-up',
    iconClasses: 'text-[#760000]',
    link: '/payouts',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    type: 'divider',
  },
  {
    id: 'convert-funds',
    title: 'sidebar:conversions',
    subtitle: 'sidebar:conversionsSubtitle',
    type: 'basic',
    icon: 'fa-arrow-circle-left',
    iconClasses: 'text-[#5c5c5c]',
    link: '/conversions',
    queryParamsHandling: '',
    hiddenFull: false,
  },
  {
    id: 'settings',
    title: 'sidebar:settings',
    type: 'collapsable',
    icon: 'fa-gear',
    link: '/settings',
    queryParamsHandling: '',
    hiddenFull: false,
    children: [
      {
        id: 'providers',
        title: 'sidebar:verifiedProviders',
        type: 'basic',
        link: '/providers',
        queryParamsHandling: '',
        hiddenFull: false,
      },
      {
        id: 'bank-accounts.company',
        title: 'sidebar:companyAccounts',
        type: 'basic',
        link: '/bank-accounts/company',
        queryParamsHandling: 'merge',
        hiddenFull: false,
      },
      {
        id: 'settings.integrations',
        title: 'sidebar:settingsIntegrations',
        type: 'basic',
        link: '/settings/integrations',
        queryParamsHandling: '',
        hiddenFull: false,
      },
      {
        id: 'settings.company',
        title: 'sidebar:settingsCompany',
        type: 'basic',
        link: '/settings/company',
        queryParamsHandling: '',
        hiddenFull: false,
      },
      {
        id: 'settings.invoice_profiles',
        title: 'sidebar:settingsInvoiceProfiles',
        type: 'basic',
        link: '/settings/invoice_profiles',
        queryParamsHandling: '',
        hiddenFull: false,
      },
      {
        id: 'settings.users',
        title: 'sidebar:settingsUsers',
        type: 'basic',
        link: '/settings/users',
        queryParamsHandling: '',
        hiddenFull: false,
      },
      {
        id: 'settings.custom_spread',
        title: 'sidebar:settingsCustomSpread',
        type: 'basic',
        link: '/settings/custom_spread',
        queryParamsHandling: '',
        hiddenFull: false,
      },
    ],
  },
  {
    id: 'storybook',
    title: 'Storybook',
    type: 'collapsable',
    icon: 'fa-book-open-cover',
    link: '/storybook',
    queryParamsHandling: '',
    hiddenFull: false,
    children: [
      {
        id: 'storybook.timeline',
        title: 'Timeline',
        type: 'basic',
        link: '/storybook/timeline',
        queryParamsHandling: 'merge',
        hiddenFull: false,
      },
      {
        id: 'storybook.messages',
        title: 'Messages',
        type: 'basic',
        link: '/storybook/messages',
        queryParamsHandling: 'merge',
        hiddenFull: false,
      },
    ],
  },
];
